<template>
  <div class="wine-details-container">
    <div
      v-if="hasDetails"
      class="wine-details-list"
    >
      <!-- Tasting Notes -->

      <div
        v-if="tastingNotes.length > 0 || hasTastingNoteFiles"
        class="wine-details-list-item"
      >
        <div
          :class="{expanded: showContent.tastingNotes}"
          class="heading"
          @click="toggleContent('tastingNotes')"
        >
          <WineProductSvgIcons
            name="TastingNotesIcon"
            class="category-icon"
          />
          <h3>Tasting Notes</h3>
          <WineProductSvgIcons
            name="ChevronIcon"
            class="accordion-icon"
          />
        </div>
        <transition-group name="slide-fade">
          <template v-if="showContent.tastingNotes || hasTastingNoteFiles">
            <ul
              v-if="showContent.tastingNotes"
              key="tasting-notes-1"
              class="tasting-notes-list"
            >
              <li
                v-for="(note, index) in tastingNotesDisplay"
                :key="index"
                class="tasting-note"
              >
                <h4 class="label">
                  {{ note.title }}
                </h4>
                <div class="description">
                  {{ note.text }}
                </div>
              </li>
            </ul>

            <!-- Previous Tasting Notes -->
            <template v-if="hasTastingNoteFiles && showContent.tastingNotes">
              <div
                v-for="(file, index) in previousTastingNotes"
                :key="index"
                class="previous-tasting-notes"
              >
                <div class="file-container">
                  <router-link
                    :to="''"
                    :href="previousTastingNotesFiles[index]"
                    :title="prevNotesTitle(file)"
                    target="_blank"
                  >
                    <WineProductSvgIcons
                      name="PreviousNotesIcon"
                      class="category-icon"
                    />
                    <div class="title">
                      <template v-if="dataTitle(file)">
                        {{ dataTitle(file) }}
                      </template>
                      <template v-else>
                        Download Tasting Notes
                      </template>
                    </div>
                  </router-link>
                </div>
              </div>
            </template>
          </template>
        </transition-group>
      </div>
      <!-- Wine Making -->
      <div
        v-if="wineMaking.length > 0"
        class="wine-details-list-item"
      >
        <div
          :class="{expanded: showContent.wineMaking}"
          class="heading"
          @click="toggleContent('wineMaking')"
        >
          <WineProductSvgIcons
            name="WineMakingIcon"
            class="category-icon"
          />
          <h3>Notes</h3>

          <WineProductSvgIcons
            name="ChevronIcon"
            class="accordion-icon"
          />
        </div>
        <transition name="slide-fade">
          <template v-if="showContent.wineMaking">
            <ul class="tasting-notes-list">
              <li
                v-for="(note, index) in wineMakingDisplay"
                :key="`wm-${index}`"
                class="tasting-note"
              >
                <h4 class="label">
                  {{ note.title }}
                </h4>
                <div class="description">
                  {{ note.text }}
                </div>
              </li>
            </ul>
          </template>
        </transition>
      </div>
      <!-- Technical -->
      <div
        v-if="technicalNotes.length > 0 || features.length > 0"
        class="wine-details-list-item"
      >
        <div
          :class="{expanded: showContent.technical}"
          class="heading"
          @click="toggleContent('technical')"
        >
          <WineProductSvgIcons
            name="TecnicalNotesIcon"
            class="category-icon"
          />
          <h3>Technical</h3>
          <WineProductSvgIcons
            name="ChevronIcon"
            class="accordion-icon"
          />
        </div>

        <transition name="slide-fade">
          <template v-if="showContent.technical">
            <ul class="tasting-notes-list grid">
              <li
                v-for="(note, index) in technicalNotesDisplay"
                :key="`tn-${index}`"
                class="tasting-note"
              >
                <h4 class="label">
                  {{ note.title }}
                </h4>
                <div class="description">
                  {{ note.text }}
                </div>
              </li>
              <li
                v-for="(feature, index) in featuresDisplay"
                :key="`f-${index}`"
                class="tasting-note"
              >
                <h4 class="label">
                  {{ feature.title }}
                </h4>
                <div class="description">
                  {{ feature.text }}
                </div>
              </li>
            </ul>
          </template>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import WineProductSvgIcons from './WineProductSvgIcons'

export default {
  name: 'product-details-wine',
  components: {
    WineProductSvgIcons
  },
  props: {
    technicalNotes: {
      type: Array,
      required: true
    },
    features: {
      type: Array,
      required: true
    },
    tastingNotes: {
      type: Array,
      required: true
    },
    wineMaking: {
      type: Array,
      required: true
    },
    previousTastingNotes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showContent: {
        tastingNotes: false,
        wineMaking: false,
        technical: false
      },
      previousTastingNotesFiles: []
    }
  },
  computed: {
    hasTastingNoteFiles() { return this.previousTastingNotes.length > 0 },
    hasDetails() {
      if (
        this.technicalNotes.length > 0 ||
        this.tastingNotes.length > 0 ||
        this.wineMaking.length > 0 ||
        this.features.length > 0 ||
        this.hasTastingNoteFiles
      ) {
        return true
      }
      else {
        return false
      }
    },
    tastingNotesDisplay() { return this.displayNotes(this.tastingNotes, 'tasting') },
    wineMakingDisplay() { return this.displayNotes(this.wineMaking, 'winemaking') },
    technicalNotesDisplay() { return this.displayNotes(this.technicalNotes, 'technote') },
    featuresDisplay() { return this.displayNotes(this.features, 'features') }
  },
  mounted() {
    if (this.previousTastingNotes) {
      this.getPreviousTastingNotesFiles()
    }
  },
  methods: {
    dataTitle(file) {
      if (file && file.file && file.file.data && file.file.data.title) return file.file.data.title
      return ''
    },
    prevNotesTitle(file) {
      if (file && file.file && file.file.title) return file.file.title
      return 'Download Tasting Notes'
    },
    displayNotes(list, type) {
      const items = []
      const notes = this.$store.getters['products/getMap']('variable')[type]
      for (const item of list) {
        items.push({ ...item, title: notes[item.title] ?? item.title.ucFirst() })
      }
      return items
    },
    getPreviousTastingNotesFiles() {
      for (const [index, { file }] of this.previousTastingNotes.entries()) {
        this.$store.dispatch('filestore/getFileURL', file)
          .then(href => {
            this.$set(this.previousTastingNotesFiles, index, href)
          })
      }
    },
    toggleContent(item) {
      this.showContent[item] = !this.showContent[item]
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@scss/custom.scss";

.wine-details-container {
  .wine-details-list {
    width: 100%;

    .heading {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: center;
      align-items: center;
      padding: 0.75em 0em;
      margin-bottom: 0.75em;
      border-bottom: 1px solid;
      border-color: var(--main-product-detail-border-color);
      cursor: pointer;
      h3 {
        font-size: 1.5em;
        margin: 0em;
      }
      .category-icon {
        margin-right: 1em;
      }
     ::v-deep .icon-container {
        .icon {
          width: 2.5em;
          height: 2.5em;

          fill: var(--main-text-heading-color);
        }
      }
      .accordion-icon {
        margin-left: auto;
       ::v-deep .icon {
          @include transition(transform 0.2s);
        }
      }
      &.expanded {
        .accordion-icon {
         ::v-deep .icon {
            transform-origin: center;
            transform: rotate(180deg);
          }
        }
      }
    }

    .tasting-notes-list {
      margin: 0 0 1em 0;
      list-style: none;
      padding: 0em;

      .tasting-note {
        margin-bottom: 1em;
        margin-left: 3.5em;
      }

      &.grid {
        display: flex;
        flex-wrap: wrap;

        li {
          flex: 1;
          min-width: 50%;
          margin-bottom: 1em;
        }
      }
    }

    .file-container {
      a {
        //border: 1px solid var(--main-white);
        border-radius: 0.25em;
        padding: 0.5em 1em;
        //color: var(--main-white);
        font-size: 1em;
        transition: var(--main-transition);
        //background-color: var(--main-primary);
        display: flex;
        align-items: center;
        @include transition(background-color 0.3s);
        @include hover-focus {
          text-decoration: none;
          //background-color: var(--main-primary-dark);
        }

        img {
          height: 2em;
          margin-right: 1em;
        }
      }
    }
  }
}
</style>
